import React from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import CloseRounded from "@mui/icons-material/CloseRounded";
import Settings from "components/dashboard/Settings";

/** Settings on top of whatever page the user is on, opened from the account menu. */
const SettingsDialog = ({ open, onClose }) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen={fullScreen}
      fullWidth
      maxWidth="md"
      scroll="paper"
      aria-labelledby="settings-dialog-title"
    >
      <DialogTitle
        id="settings-dialog-title"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        Settings
        <IconButton aria-label="Close settings" edge="end" onClick={onClose}>
          <CloseRounded />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        {/* No `open &&` guard: Dialog already unmounts this once it has closed, so it
            still doesn't load billing and MFA state for nothing, and a guard would
            blank the settings while the dialog fades out. */}
        <Settings embedded />
      </DialogContent>
    </Dialog>
  );
};

export default SettingsDialog;
